import { del, get, post, put } from "../client";
import {
  COUPON_BY_ID,
  CREATE_COUPON,
  GET_COUPONS,
  GET_COUPONS_USAGE_HISTORY,
} from "../routes";

export default {
  get_coupons: async (page, size) => await get(GET_COUPONS(page, size)),

  get_coupons_usage_history: async (page, size) =>
    await get(GET_COUPONS_USAGE_HISTORY(page, size)),

  create_coupon: async (data) => await post(CREATE_COUPON, data),

  get_coupon_by_id: async (id) => await get(COUPON_BY_ID(id)),

  edit_coupon: async (id, data) => await put(COUPON_BY_ID(id), data),

  delete_coupon: async (id) => await del(COUPON_BY_ID(id)),
};
